// Module
var code = `<table class="table" at-table at-list="\$ctrl.getUserLedgers()">
  <thead></thead>
  <tbody class="tbody">
  <tr>
    <td at-title="No">
      {{item.index}}
    </td>
    <td at-implicit at-attribute="name" at-title="General ledger name"></td>
    <td at-implicit at-attribute="branchName" at-title="Branch name"></td>
    <td at-implicit at-attribute="branchCode" at-title="Branch code"></td>
    <td class="open-link-container">
      <a class="btn btn-primary" ng-href="{{\$ctrl.detailLink}}/{{item.id}}">Open</a>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/common/gl-account-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;